import { Message } from 'primereact/message'
import { portalAppUrl } from './publicConfig'

const portalLayoutUrl = layoutUuid => `${portalAppUrl}/layouts/${encodeURIComponent(layoutUuid)}`

// Shown when the public API reports a layout as CLAIMED (moved into a Chain.io workspace).
// 'page' replaces the editor on load; 'banner' sits above an already-open, now read-only
// draft, and opens the portal in a new tab so the unsaved draft stays visible here.
export default function ClaimedLayoutNotice ({ layoutUuid, variant = 'page' }) {
  if (variant === 'banner') {
    return (
      <Message
        severity='warn'
        className='publicLayoutBuilderPage-readonly-notice'
        content={(
          <div className='publicLayoutBuilderPage-claimed-banner'>
            <span>This layout was moved into a Chain.io workspace, so changes here are no longer saved. Anything shown here that isn't in the workspace copy was not saved.</span>
            <a className='p-button p-button-sm' href={portalLayoutUrl(layoutUuid)} target='_blank' rel='noopener noreferrer'>
              Open in Chain.io
            </a>
          </div>
        )}
      />
    )
  }
  return (
    <section className='publicLayoutBuilderPage-unavailable'>
      <h1>This layout has moved into a Chain.io workspace.</h1>
      <p>Sign in to Chain.io to open it. If you don't have access, ask the person who added it to their workspace.</p>
      <a className='p-button' href={portalLayoutUrl(layoutUuid)}>Open in Chain.io</a>
    </section>
  )
}
